import OwnerRequestRegistrationRequestBase from './base/OwnerRequestRegistrationRequestBase';

/**
 * @class OwnerRequestRegistrationRequest
 * @extends OwnerRequestRegistrationRequestBase
 */
class OwnerRequestRegistrationRequest extends OwnerRequestRegistrationRequestBase {

}

export default OwnerRequestRegistrationRequest;
